export default __webpack_public_path__ + "static/media/portfolio-142.6af4e972.jpg";